<template>
  <!-- 核心修改：添加 v-if="hasArticles" 控制整个组件的显示隐藏 -->
  <div class="article-recommend-container" v-if="hasArticles">
    <!-- 标题 + 布局切换按钮 组合栏 -->
    <div class="header-bar">
      <h2 class="main-title">
        <i class="el-icon-menu title-icon"></i>
        为您推荐
      </h2>
      <div class="layout-switch">
        <button class="switch-btn" :class="{ active: localLayout === 'single' }" @click="changeLayout('single')" aria-label="单列布局">
          <i class="el-icon-minus single-icon"></i>
        </button>
        <button class="switch-btn" :class="{ active: localLayout === 'masonry' }" @click="changeLayout('masonry')" aria-label="瀑布流布局">
          <i class="el-icon-s-grid masonry-icon"></i>
        </button>
      </div>
    </div>

    <!-- 文章列表区域 -->
    <div class="article-list" :class="{ 'single-layout': localLayout === 'single', 'masonry-layout': localLayout === 'masonry' }">
      <!-- eslint-disable-next-line vue/no-parsing-error -->
      <div class="article-card" v-for="(article, index) in filteredArticles" :key="article.sid" :class="{ expanded: article.isExpanded }" :style="{ animationDelay: `${index * 0.05}s` }">
        <!-- 重新设计的 CLC 标签位置 - 卡片顶部角标 -->
        <div class="clc-badge-wrapper" :class="getClcClass(article.clc_part)">
          <span class="clc-badge-text">{{ article.clc_part }}</span>
        </div>

        <div class="card-content">
          <a href="javascript:void(0);" class="article-title-link" :title="article.title" @click="openArticleInRightPanel(article)">
            <h3 class="article-title">{{ article.title }}</h3>
          </a>

          <div class="article-meta">
            <div class="meta-item">
              <i class="el-icon-user meta-icon"></i>
              <span class="meta-text">{{ truncateText(article.author, 20) }}</span>
            </div>
            <div class="meta-divider">|</div>
            <div class="meta-item">
              <i class="el-icon-date meta-icon"></i>
              <span class="meta-text">{{ article.publish_date }}</span>
            </div>
            <div class="meta-divider">|</div>
            <div class="meta-item">
              <i class="el-icon-office-building meta-icon"></i>
              <span class="meta-text">{{ truncateText(article.publisher, 20) }}</span>
            </div>
          </div>

          <div class="subject-tag">
            <i class="el-icon-s-data tag-icon"></i>
            <span>{{ truncateText(article.clc_subject, 40) }}</span>
          </div>

          <div class="research-target" v-if="article.research_goal">
            <p class="section-content">{{ article.research_goal }}</p>
          </div>

          <div class="collapse-content">
            <!-- 研究意义：修改为"研究意义（核心价值）" -->
            <div class="significance-info" v-if="article.significance">
              <div class="significance-level">
                <span class="significance-label">研究意义（核心价值）</span>
              </div>
              <p class="significance-desc">{{ article.significance }}</p>
            </div>
            <div class="cost-info" v-if="article.research_cost">
              <div class="cost-level">
                <span class="cost-label">成本级别：</span>
                <span class="cost-value">{{ getCostData(article.research_cost)["成本级别"] }}</span>
              </div>
              <p class="cost-desc">{{ getCostData(article.research_cost)["成本评估说明"] }}</p>
            </div>
          </div>
        </div>

        <button class="toggle-btn" @click="toggleExpand(article)" aria-label="查看更多" v-if="article.research_goal || article.significance || article.research_cost">
          <i class="el-icon-arrow-down toggle-icon"></i>
        </button>
      </div>

      <!-- 移除空状态提示：因为没有数据时整个组件会隐藏 -->
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { openArticleDetail } from "../utils/openArticleDetail";

export default {
  name: "ArticleRecommend",
  props: {
    articles: {
      type: Array,
      default: () => [],
    },
    layout: {
      type: String,
      default: "single",
    },
  },
  data() {
    return {
      filteredArticles: [],
      articleData: [],
      // 本地布局状态
      localLayout: "masonry",
      // 是否显示iframe弹窗
      showIframe: false,
      // 当前选中的文章
      currentArticle: null,
    };
  },
  computed: {
    hasArticles() {
      return Array.isArray(this.filteredArticles) && this.filteredArticles.length > 0;
    },
  },
  watch: {
    // 监听props变化，同步到本地状态
    layout(newVal) {
      this.localLayout = newVal;
    },
  },
  mounted() {
    if (localStorage.getItem("token")) {
      this.get_recommend_paper();
    }
    // this.get_recommend_paper();
  },
  methods: {
    async get_recommend_paper() {
      try {
        const res = await this.$http.get(this.globalUrl.recommend_paper);
        this.articleData = res.data.map(item => ({ ...item, isExpanded: false }));
        this.filteredArticles = [...this.articleData];
      } catch (error) {
        console.error("获取推荐文章失败:", error);
        this.articleData = [];
        this.filteredArticles = [];
      }
    },
    getClcClass(clcPart) {
      switch (clcPart) {
        case "SCIE-Q1":
          return "clc-q1";
        case "SCIE-Q2":
          return "clc-q2";
        case "SCIE-Q3":
          return "clc-q3";
        case "SCIE-Q4":
          return "clc-q4";
        default:
          return "clc-other";
      }
    },
    truncateText(text, maxLength) {
      if (!text) return "";
      return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
    },
    getCostData(costStr) {
      try {
        return JSON.parse(costStr) || {};
      } catch (e) {
        return {
          成本级别: "未知",
          成本评估说明: "无法解析成本信息",
        };
      }
    },
    toggleExpand(article) {
      article.isExpanded = !article.isExpanded;
    },
    // 切换布局
    changeLayout(layoutType) {
      this.localLayout = layoutType;
      this.$emit("update:layout", layoutType);
    },
    // 在右侧面板打开文章
    openArticleInRightPanel(article) {
      // 发送兴趣保存请求
      this.$http
        .post(this.globalUrl.interest_save, { interest: article.research_goal })
        .then(response => {
          console.log("兴趣保存成功", response);
        })
        .catch(error => {
          console.error("兴趣保存失败", error);
        });

      openArticleDetail(article);
    },
  },
};
</script>

<style scoped>
/* 全局容器 */
.article-recommend-container {
  width: 95%;
  max-width: 1200px;
  margin: 40px auto;
  padding: 0 20px;
  font-family: "Inter", "Microsoft YaHei", "PingFang SC", sans-serif;
  box-sizing: border-box;
}

/* ========== 标题栏核心设计 ========== */
.header-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.main-title {
  font-size: 16px;
  font-weight: 400;
  color: #9ca3af;
  margin: 0;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.title-icon {
  font-size: 18px;
}

/* 布局切换按钮区域 */
.layout-switch {
  display: flex;
  gap: 8px;
}

.switch-btn {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.switch-btn.active {
  background-color: #3b82f6;
  border-color: #3b82f6;
  color: white;
}

.switch-btn:hover:not(.active) {
  border-color: #3b82f6;
  background-color: #f8fafc;
}

.single-icon,
.masonry-icon {
  font-size: 16px;
  color: #94a3b8;
  transition: color 0.2s ease;
}

.switch-btn.active .single-icon,
.switch-btn.active .masonry-icon {
  color: white;
}

/* ========== 布局样式 ========== */
.article-list.single-layout {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.single-layout .article-card {
  width: 100%;
  height: auto;
  max-height: 400px;
  overflow: hidden;
}
.single-layout .article-card.expanded {
  max-height: none;
  min-height: 200px;
}

.article-list.masonry-layout {
  column-count: 3;
  column-gap: 24px;
}
.masonry-layout .article-card {
  break-inside: avoid;
  margin-bottom: 24px;
  width: 100%;
  height: auto;
}

/* ========== 卡片样式 ========== */
.article-card {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.1s cubic-bezier(0.25, 0.8, 0.25, 1);
  position: relative; /* 新增：为角标提供定位参考 */
  display: flex;
  flex-direction: column;
  transform: translateY(50px);
  opacity: 0;
  /* 修改核心：动画时长从 0.5s 改为 0.3s，缓动函数调整为更轻快的 ease-out */
  animation: slideUp 0.2s ease-out forwards;
}

/* 修改动画缓动：ease-out 让动画先快后慢，视觉上更轻快 */
@keyframes slideUp {
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* 重新设计的 CLC 角标样式 - 原色系+高灰度（互换Q1和Q3颜色） */
.clc-badge-wrapper {
  position: absolute;
  top: 0;
  right: 0;
  width: 80px;
  height: 80px;
  overflow: hidden;
  z-index: 1;
}

.clc-badge-text {
  position: absolute;
  top: 12px;
  right: -36px;
  width: 120px;
  padding: 4px 0;
  color: white;
  font-size: 11px;
  font-weight: 600;
  text-align: center;
  text-transform: uppercase;
  transform: rotate(45deg);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 核心修改：互换 Q1 和 Q3 的高灰度配色 */
.clc-q1 .clc-badge-text {
  background: linear-gradient(135deg, #b88c52, #a1763a);
} /* 原Q3橙黄系高灰度 */
.clc-q2 .clc-badge-text {
  background: linear-gradient(135deg, #6a89cc, #506fd1);
} /* 蓝系高灰度 */
.clc-q3 .clc-badge-text {
  background: linear-gradient(135deg, #5a7f6c, #416653);
} /* 原Q1绿系高灰度 */
.clc-q4 .clc-badge-text {
  background: linear-gradient(135deg, #b96a6a, #a05050);
} /* 红系高灰度 */
.clc-other .clc-badge-text {
  background: linear-gradient(135deg, #848c96, #6d747d);
} /* 灰蓝系高灰度 */

.card-content {
  padding: 28px;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* 文章标题 */
.article-title-link {
  text-decoration: none;
  width: 100%;
  display: inline-block;
}
.article-title {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.5;
  margin: 0;
  flex-shrink: 0;
  transition: color 0.2s ease;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  word-break: break-all;
}
.article-title-link:hover .article-title {
  color: #3b82f6;
}

/* 文章元信息 */
.article-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px 12px;
  background: #f8fafc;
  border-radius: 8px;
  flex-shrink: 0;
  font-size: 12px;
}
.meta-item {
  display: flex;
  align-items: center;
  gap: 4px;
}
.meta-icon {
  color: #94a3b8;
  font-size: 12px;
}
.meta-text {
  color: #334155;
  line-height: 1.4;
  word-break: break-all;
}
.meta-divider {
  color: #e2e8f0;
  font-size: 10px;
}

/* 学科标签 */
.subject-tag {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #3b82f6;
  font-weight: 500;
  padding: 6px 10px;
  background: rgba(59, 130, 246, 0.08);
  border-radius: 8px;
  flex-shrink: 0;
}
.tag-icon {
  font-size: 12px;
}

/* 研究目标 */
.research-target .section-content {
  font-size: 13px;
  color: #475569;
  line-height: 1.5;
  margin: 0;
  padding: 12px 16px;
  background-color: #f8fafc;
  border-radius: 8px;
}

/* 折叠内容 */
.collapse-content {
  display: none;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;
}
.article-card.expanded .collapse-content {
  display: flex;
}

/* 研究意义样式：与成本级别统一 */
.significance-info {
  padding: 10px;
  background-color: #f8fafc;
  border-radius: 8px;
}
.significance-level {
  font-size: 13px;
  line-height: 1.5;
  margin-bottom: 4px;
}
.significance-label {
  font-weight: 600;
  color: #1e293b;
}
.significance-value {
  color: #3b82f6;
}
.significance-desc {
  font-size: 12px;
  color: #475569;
  line-height: 1.4;
  margin: 0;
  padding-top: 4px;
  border-top: 1px solid #e2e8f0;
}

/* 成本级别样式 */
.cost-info {
  padding: 10px;
  background-color: #f8fafc;
  border-radius: 8px;
}
.cost-level {
  font-size: 13px;
  line-height: 1.5;
  margin-bottom: 4px;
}
.cost-label {
  font-weight: 600;
  color: #1e293b;
}
.cost-value {
  color: #3b82f6;
}
.cost-desc {
  font-size: 12px;
  color: #475569;
  line-height: 1.4;
  margin: 0;
  padding-top: 4px;
  border-top: 1px solid #e2e8f0;
}

/* 展开按钮 */
.toggle-btn {
  width: 60px;
  height: 30px;
  margin: 0 auto 10px;
  background: transparent;
  border: 1px solid #e2e8f0;
  border-radius: 15px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}
.toggle-btn:hover {
  background-color: #f8fafc;
  border-color: #3b82f6;
}
.toggle-icon {
  font-size: 14px;
  color: #94a3b8;
  transition: transform 0.2s ease, color 0.2s ease;
}
.article-card.expanded .toggle-icon {
  transform: rotate(180deg);
  color: #3b82f6;
}

/* 响应式适配 */
@media (max-width: 1024px) {
  .article-list.masonry-layout {
    column-count: 2;
  }
}

@media (max-width: 768px) {
  .article-list.masonry-layout {
    column-count: 1;
  }
  .main-title {
    font-size: 14px;
  }
  .switch-btn {
    width: 32px;
    height: 32px;
  }
  .single-icon,
  .masonry-icon {
    font-size: 14px;
  }
  .article-title {
    font-size: 16px;
  }
  /* 移动端调整角标大小 */
  .clc-badge-wrapper {
    width: 70px;
    height: 70px;
  }
  .clc-badge-text {
    top: 8px;
    right: -25px;
    width: 110px;
    font-size: 10px;
  }
}

@media (max-width: 480px) {
  .article-recommend-container {
    width: 98%;
    padding: 0 10px;
  }
  .card-content {
    padding: 20px;
  }
  .article-meta {
    gap: 6px;
  }
  /* 小屏手机进一步调整角标 */
  .clc-badge-wrapper {
    width: 60px;
    height: 60px;
  }
  .clc-badge-text {
    top: 6px;
    right: -28px;
    width: 100px;
    font-size: 9px;
    padding: 3px 0;
  }
}
</style>
